import router from '@/shared/router'
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import lojas from '@/domains/shared/configuracoes/lojas/router/routes'
import usuarios from '@/domains/shared/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/shared/configuracoes/grupos_usuarios/router/routes'
import permissoes from '@/domains/shared/configuracoes/permissoes/router/routes'
import planos from '@/domains/shared/configuracoes/planos/router/routes'
import atendimentos from '@/domains/atendimentos/atendimentos/router/routes'
import dominios from '@/domains/shared/configuracoes/dominios/router/routes'
import ajuda from '@/domains/shared/auxiliares/ajuda/router/routes'

let childrenRoutes = []
const paths = require.context('../', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => { childrenRoutes.push(val) })
    }
})

const routes = [
    {
        path: '/area_cliente_adm',
        component: () => import('@/shared/components/layout/Interno'),
        children: childrenRoutes,
    },
    {
        path: '/area_cliente_adm/sistema/acessar_erp',
        redirect: '/inicio'
    },

    ...formataRotasGlobais('area_cliente_adm', atendimentos),
    ...formataRotasGlobais('area_cliente_adm', dominios),
    ...formataRotasGlobais('area_cliente_adm', lojas),
    ...formataRotasGlobais('area_cliente_adm', usuarios),
    ...formataRotasGlobais('area_cliente_adm', gruposUsuarios),
    ...formataRotasGlobais('area_cliente_adm', permissoes),
    ...formataRotasGlobais('area_cliente_adm', planos),
    ...formataRotasGlobais('area_cliente_adm', ajuda)
]

router.addRoutes(routes)

export default router
